import PhotoSwipeLightbox from "photoswipe/lightbox";

const getDataSource = (covers, { width, height }) => {
    return covers.map((C) => {
        const src = C.querySelector("picture > img").getAttribute("src");
        const _filePath = src.replace(/https:\/\/www\.newsbeast\.gr/, "");

        //make sizes
        const srcset = [420, 740, 980, 1200, 1600]
            .map((s) => `/image/s${s}x/file${_filePath} ${s}w`)
            .join(", ");

        return {
            srcset,
            src,
            width: width,
            height: height,
        };
    });
};
const openLightBox = (dataSource) => {
    const lightbox = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: () => import("photoswipe"),
    });



    lightbox.on("close", () => setTimeout(lightbox.destroy(), 1));
    lightbox.on("change", () => {

        try {
            gtag('event', 'page_view', {
                page_title: `${document.title}`,
                page_location: `${location.pathname}`
            })
        } catch (err) {
            //console.error(err)
        }

    });
    lightbox.init();
    lightbox.loadAndOpen();
};

const _onCoverClicked = (e, { width, height }) => {
    e.preventDefault();
    const mainCover = [...document.querySelectorAll(".presentationLightBox")];
    const covers = [...document.querySelectorAll("#newspaperGroups a")];
    openLightBox(getDataSource([...mainCover, ...covers], { width, height }));
};

document.addEventListener("DOMContentLoaded", () => {
    const btn = document.getElementsByClassName("presentationLightBox");
    if (btn && btn.length > 0) {
        const mainCoverBtn = btn[0]
        const width = mainCoverBtn.attributes['data-width-cover'].value;
        const height = mainCoverBtn.attributes['data-height-cover'].value;
        mainCoverBtn.addEventListener("click", (e) => _onCoverClicked(e, { width, height }));

    }
});